import * as React from "react";

function SvgCalender(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={18.869} height={18.817} {...props}>
      <path
        d="M14.271 0a.719.719 0 00-.658.766v.605H5.254V.766A.719.719 0 004.6 0a.719.719 0 00-.66.766v.605H1.512A1.655 1.655 0 000 3.136v13.917a1.655 1.655 0 001.512 1.764h15.845a1.655 1.655 0 001.512-1.764V3.136a1.659 1.659 0 00-1.513-1.764h-2.428V.766A.719.719 0 0014.271 0zm0 4.3a.72.72 0 00.658-.768v-.4h2.429v2.4H1.512v-2.4h2.429v.4A.72.72 0 004.6 4.3a.72.72 0 00.657-.768v-.4h8.358v.4a.72.72 0 00.657.768zM1.512 17.053V7.067h15.845v9.986zM13.38 8.56H5.488a.72.72 0 00-.657.768.719.719 0 00.657.766h7.894a.719.719 0 00.658-.766.724.724 0 00-.66-.768zm0 4.154H5.488a.776.776 0 000 1.534h7.894a.776.776 0 000-1.534z"
        fill="#3c4252"
      />
    </svg>
  );
}

export default SvgCalender;
